import { render, staticRenderFns } from "./ReadinessCatalogs.vue?vue&type=template&id=477d1553&scoped=true"
import script from "./ReadinessCatalogs.vue?vue&type=script&lang=js"
export * from "./ReadinessCatalogs.vue?vue&type=script&lang=js"
import style0 from "./ReadinessCatalogs.vue?vue&type=style&index=0&id=477d1553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d1553",
  null
  
)

export default component.exports